import React from 'react';
import { about5, heroVideo, arashBg, aboutBg } from '../../assets/images';
import Header from '../../Components/Header/Header';
import Hero from '../../Components/home/Hero/Hero';
import WhyUs from '../../Components/home/WhyUs/WhyUs';
import Categories from '../../Components/home/Categories/Categories';
import Solutions from '../../Components/home/Solutions/Solutions';
import ServicesItems from './ServicesItems/ServicesItems';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';

const Services = () => {
 
   const { t, i18n } = useTranslation();

  return (
    <>
        <Breadcrumb title={t("Xidmətlər")}/>
      <ServicesItems/>
    </>
  );
};

export default Services;
